import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakPoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakPoints;

const Perk = styled.div`
  label: Perk;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
  color: var(--colors-white);

  &:last-child {
    margin-bottom: 0;
  }

  @media (${widthSmall}) {
    text-align: initial;
    flex-direction: row;
  }

  @media (${widthMedium}) {
    margin-bottom: 2rem;
  }
`;

const PerkIcon = styled.svg`
  label: PerkIcon;

  width: 2rem;
  margin-bottom: 0.3125rem;
  display: block;
  flex: 0 0 auto;

  @media (${widthSmall}) {
    width: 2.75rem;
    margin-bottom: 0;
    margin-right: 1.5rem;
  }

  ${({ color }) => {
    switch (color) {
      case 'scooter':
        return css`
          fill: var(--colors-scooter);
        `;
      case 'orange':
        return css`
          fill: var(--colors-orange-base);
        `;
      case 'gold':
        return css`
          fill: var(--colors-honey-gold-base);
        `;
      case 'blue':
        return css`
          fill: var(--colors-blue-bright);
        `;
      case 'pomegranate':
        return css`
          fill: var(--colors-pomegranate);
        `;
      default:
        return css`
          fill: var(--colors-black);
        `;
    }
  }}
`;

const PerkDescription = styled.h4`
  label: PerkDescription;

  display: none;
  color: var(--colors-scarpa-flow);

  @media (${widthSmall}) {
    display: block;
  }
`;

const PerkDescriptionMobile = styled.h4`
  label: PerkDescriptionMobile;

  color: var(--colors-scarpa-flow);

  @media (${widthSmall}) {
    display: none;
  }
`;

export const Styled = {
  Perk,
  PerkIcon,
  PerkDescription,
  PerkDescriptionMobile,
};
